import React from 'react';

import { PageHeaderLayout } from '@/shared/components';

const ReportPage: React.FC = () => {
  return (
    <PageHeaderLayout headerName={'Report Page'} />
  )
}

export default ReportPage;